import React, { useState } from "react";
import {
  Grid,
  Button,
  Typography,
  Paper,
  Box,
  makeStyles,
} from "@material-ui/core";
import {
  AccountBalanceOutlined,
  InfoOutlined,
  HeadsetMicOutlined,
} from "@material-ui/icons";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { useNavigate } from "react-router-dom";
import brandTheme from "brandTheme/Theme";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    minHeight: "100vh",
    padding: theme.spacing(3),
    [theme.breakpoints.down(600)]: {
      padding:'0px'
    },
  },

  card: {
    maxWidth: 780,
    margin: "30px auto",
    padding: "45px 35px",
    borderRadius: 24,
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,.08)",
    [theme.breakpoints.down(600)]: {
      padding:'0px !important',
      boxShadow:'none',
      background:'transparent'
    },
  },

  image: {
    width: 180,
    marginBottom: 20,
  },

  title: {
    fontSize: 42,
    fontWeight: 700,
    color: brandTheme.mainColor,
    marginBottom: 10,
  },

  success: {
    color: brandTheme.secondaryColor,
    fontSize: 28,
    fontWeight: 700,
    marginBottom: 25,
  },

  description: {
    color: "#555",
    fontSize: 18,
    marginBottom: 35,
    lineHeight: 1.7,
  },

  infoCard: {
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    background: "#EEF9F2",
    border: "1px solid #D7F2E2",
    borderRadius: 15,
    padding: 18,
    marginBottom: 20,
  },

  noteCard: {
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    background: "#F7FBFF",
    border: "1px solid #D6E7FF",
    borderRadius: 15,
    padding: 18,
    marginBottom: 35,
  },

  iconCircle: {
    width: 60,
    height: 60,
    borderRadius: "50%",
    background: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 18,
    flexShrink: 0,
  },

  button: {
    background: brandTheme.mainColor,
    color: "#fff",
    textTransform: "none",
    fontSize: 18,
    padding: "14px 45px",
    borderRadius: 10,
    "&:hover": {
      background: brandTheme.secondaryColor,
    },
  },

  helpCard: {
    maxWidth: 780,
    margin: "25px auto",
    padding: 25,
    borderRadius: 18,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 5px 15px rgba(0,0,0,.06)",
  },

  helpLeft: {
    display: "flex",
    alignItems: "center",
  },

  helpText: {
    marginLeft: 15,
  },

  contactBtn: {
    borderRadius: 10,
    textTransform: "none",
  },

  "@media (max-width:768px)": {
    title: {
      fontSize: 30,
    },

    success: {
      fontSize: 22,
    },

    card: {
      padding: 25,
    },

    helpCard: {
      flexDirection: "column",
      gap: 20,
      alignItems: "flex-start",
    },
  },
}));

export default function DisbursalInfo() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [callInProgress] = useState(false);
  const { enabled } = useSelector((state) => state?.login?.adminPortalData) || false;
  return (
    <>
      <Grid container className={classes.container}>
        <Grid item xs={12}>
          <SubHeader
            label="Disbursal Info"
          />
        </Grid>

        <Grid item xs={12}>
          <Paper className={classes.card}>
            <img
              src="/images/disbursalCongratulation.png"
              alt="Congratulations"
              className={classes.image}
            />

            <Typography className={classes.title}>
              Congratulations!
            </Typography>

            <Typography className={classes.success}>
              Your Loan has been Disbursed Successfully
            </Typography>

            <Box className={classes.infoCard}>
              <div className={classes.iconCircle}>
                <AccountBalanceOutlined
                  style={{ color: "#16A34A", fontSize: 34 }}
                />
              </div>

              <Typography>
                The disbursed loan amount will be credited into your registered
                bank account <b>within 30 minutes.</b>
              </Typography>
            </Box>

            <Box className={classes.noteCard}>
              <div className={classes.iconCircle}>
                <InfoOutlined style={{ color: "#1976d2", fontSize: 34 }} />
              </div>

              <Typography>
                You will receive an SMS and Email confirmation shortly.
              </Typography>
            </Box>

            <Button
              className={classes.button}
              onClick={() => navigate(enabled ? "/AdminPortal" : "/Repayment")}
            >
              Go to Dashboard
            </Button>
          </Paper>

          {/* <Paper className={classes.helpCard}>
            <div className={classes.helpLeft}>
              <HeadsetMicOutlined
                style={{
                  color: brandTheme.secondaryColor,
                  fontSize: 45,
                }}
              />

              <div className={classes.helpText}>
                <Typography variant="h6">
                  Need Help?
                </Typography>

                <Typography color="textSecondary">
                  Our support team is here for you.
                </Typography>
              </div>
            </div>

            <Button
              variant="outlined"
              color="primary"
              className={classes.contactBtn}
            >
              Contact Support
            </Button>
          </Paper> */}
        </Grid>
      </Grid>

      {callInProgress && (
        <CircularProgresss callInProgress={callInProgress} />
      )}
    </>
  );
}